import type { BlogPost } from "./blog";

export const BLOG_BIRTHDAY_PART4: BlogPost[] = [
  {
    "slug": "kak-zabronirovat-den-rozhdeniya-parusy",
    "title": "Как забронировать день рождения в «Парусах на крыше»: пошаговая инструкция",
    "metaTitle": "Как забронировать день рождения в «Парусах» | Паруса на крыше",
    "metaDescription": "Пошаговая инструкция по бронированию дня рождения в ресторане «Паруса на крыше». Скидка 20% именинникам. +7 (812) 991-10-90.",
    "keywords": "как забронировать день рождения паруса, бронирование день рождения петербург, ресторан паруса",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Забронировать день рождения в «Парусах» — просто. Несколько шагов, один звонок — и всё готово. Разбираем, как это работает.",
    "sections": [
      {
        "heading": "Шаг 1: подготовьте информацию",
        "body": "Перед звонком определитесь с: датой и временем, количеством гостей, форматом (стол в общем зале или отдельный зал), дополнительными пожеланиями (торт, цветы, особый стол). Чем конкретнее вы расскажете — тем лучше менеджер поможет.",
        "list": [
          "Дата и время",
          "Количество гостей",
          "Формат: зал или стол",
          "Пожелания: торт, декор"
        ]
      },
      {
        "heading": "Шаг 2: позвоните",
        "body": "Позвоните: +7 (812) 991-10-90. Скажите: «Хочу забронировать стол на день рождения, [дата], [количество человек]». Менеджер предложит варианты и уточнит детали. Сообщите о скидке именинникам — она применяется автоматически при предъявлении паспорта, но лучше упомянуть заранее.",
        "list": [
          "+7 (812) 991-10-90",
          "Назовите: дата, количество, формат",
          "Скидка 20% именинникам",
          "Спросите о специальных предложениях"
        ]
      },
      {
        "heading": "Шаг 3: подтвердите детали",
        "body": "После разговора вам пришлют подтверждение. Обычно — сразу. За день до события — перезвоните и подтвердите бронирование. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж. Лифт внутри комплекса.",
        "highlight": "Скидка 20% именинникам действует 7 дней до и 7 дней после дня рождения. Предъявите паспорт при оплате."
      }
    ],
    "cta": { "text": "Позвонить и забронировать", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "skidka-20-imeninikku-parusy-usloviya",
    "title": "Скидка 20% именинникам в «Парусах»: все условия и детали",
    "metaTitle": "Скидка 20% именинникам в «Парусах» — условия | Паруса",
    "metaDescription": "Скидка 20% именинникам в ресторане «Паруса на крыше»: условия, когда действует, как получить. Действует 7 дней до и после дня рождения.",
    "keywords": "скидка именинникам паруса, скидка 20 день рождения ресторан петербург, именинник скидка спб",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Скидка 20% именинникам — одно из главных предложений «Парусов». Но что именно входит в условия? Разбираем честно и подробно.",
    "sections": [
      {
        "heading": "Условия скидки",
        "body": "Скидка 20% распространяется на личный счёт именинника — то есть на то, что заказал именинник. Гости платят полную стоимость своих заказов. Скидка действует: 7 дней до даты рождения и 7 дней после. Итого — 15 дней, когда можно прийти со скидкой. Необходимо предъявить паспорт для подтверждения даты рождения.",
        "list": [
          "20% только на счёт именинника",
          "Действует 7 дней до и 7 дней после",
          "Итого: 15 дней льготного периода",
          "Нужен паспорт для подтверждения"
        ]
      },
      {
        "heading": "Десерт в подарок",
        "body": "В дополнение к скидке именинник получает десерт от шеф-кондитера в подарок. Это небольшой, но приятный жест. Если именинник хочет торт — его нужно заказать отдельно (это услуга кондитера, которая оплачивается).",
        "highlight": "Скидка 20% + десерт в подарок = конкретная выгода для каждого именинника. Это наш способ сказать: «спасибо, что отмечаете с нами»."
      },
      {
        "heading": "Как воспользоваться скидкой",
        "body": "Скажите о дне рождения при бронировании. Придите с паспортом. Официант применит скидку при оплате. Всё просто. +7 (812) 991-10-90.",
        "list": [
          "Сообщите о ДР при бронировании",
          "Принесите паспорт",
          "Скидка применяется при оплате",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Воспользоваться скидкой именинника", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "torty-na-zakaz-restoran-spb",
    "title": "Торт на заказ в ресторане Петербурга: как организовать",
    "metaTitle": "Торт на заказ в ресторане Петербурга | Паруса на крыше",
    "metaDescription": "Как заказать торт на день рождения в ресторане Санкт-Петербурга. Торт от шеф-кондитера «Парусов». Скидка 20% именинникам.",
    "keywords": "торт на заказ ресторан петербург, именной торт день рождения спб, торт шеф кондитер",
    "date": "2026-06-27",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Торт на день рождения — традиция, которая нравится всем возрастам. Но именной торт с правильной надписью и красивой подачей — это совсем другой уровень.",
    "sections": [
      {
        "heading": "Торт от шеф-кондитера: почему это важно",
        "body": "Магазинный торт несёт с собой ощущение «взяли по дороге». Торт от шеф-кондитера — это другое: он сделан для вашего праздника, с вашим именем, с датой. Это деталь, которую замечают все гости. В «Парусах» торт можно заказать через ресторан — шеф-кондитер делает под запрос.",
        "list": [
          "Торт с именем и датой — индивидуальный",
          "Вкусы: обсуждаете при заказе",
          "Подача с живой музыкой — по запросу",
          "Заказ за 3–5 дней до даты"
        ]
      },
      {
        "heading": "Как заказать торт",
        "body": "Позвоните при бронировании: +7 (812) 991-10-90. Скажите: «Хочу торт на день рождения, [дата], [количество гостей]». Обсудите: вкус, дизайн, надпись. Торт делается за 3–5 дней. Альтернатива: принести торт с собой (уточните условия — обычно возможно с посудным сбором).",
        "highlight": "Вынос торта с живой музыкой в «Парусах» — это тот момент, который снимают на видео. Это вход в личный архив праздника."
      },
      {
        "heading": "Альтернатива: свой торт",
        "body": "Можно принести торт с собой. Уточните условия при бронировании — обычно действует посудный сбор. Ресторан нарежет и подаст красиво.",
        "list": [
          "Торт от шеф-кондитера: за 3–5 дней",
          "Свой торт: с посудным сбором",
          "Вынос с музыкой: по запросу",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Заказать торт при бронировании", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "ukrashenie-zala-den-rozhdeniya-restoran",
    "title": "Украшение зала на день рождения в ресторане: что реально сделать",
    "metaTitle": "Украшение зала на день рождения в ресторане | Паруса",
    "metaDescription": "Как украсить зал на день рождения в ресторане Санкт-Петербурга. Что можно, что нельзя, что предлагает «Паруса на крыше».",
    "keywords": "украшение зала день рождения ресторан, декор день рождения спб, оформление зала праздник",
    "date": "2026-06-27",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Хочется красивое оформление на день рождения — но что ресторан позволяет? Разбираем, что можно сделать в «Парусах».",
    "sections": [
      {
        "heading": "Что можно принести в ресторан",
        "body": "Большинство ресторанов, включая «Паруса», разрешают: живые цветы (принесите сами или закажите через флориста), воздушные шарики (уточните заранее — некоторые ограничения возможны), именные карточки рассадки, банеры и баннеры (без крепления к стенам), персональные украшения стола.",
        "list": [
          "Живые цветы — всегда разрешены",
          "Шарики — уточните при бронировании",
          "Именные карточки — принесите сами",
          "Баннеры — без крепления к стенам"
        ]
      },
      {
        "heading": "Декор от «Парусов»",
        "body": "«Паруса» предлагают: праздничный декор стола (по запросу), свечи (уточните), именное меню (при больших банкетах). Живая музыка — часть атмосферы, которая заменяет многие декорации. Панорама Петербурга за окном — лучший декор.",
        "highlight": "Панорама Петербурга с 6-го этажа — лучший «декор», который вам не нужно заказывать. Это даётся автоматически."
      },
      {
        "heading": "Флористы и оформление",
        "body": "Если хотите профессиональное оформление — договоритесь с флористом самостоятельно. «Паруса» дадут ему время до начала вечера для расстановки. Уточните детали при бронировании. +7 (812) 991-10-90.",
        "list": [
          "Флорист приходит заранее — по согласованию",
          "Цветы принести самим — всегда",
          "Свечи: уточните условия",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить оформление при бронировании", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "programma-vechera-den-rozhdeniya",
    "title": "Программа вечера на день рождения в ресторане: как составить",
    "metaTitle": "Программа вечера на день рождения в ресторане | Паруса",
    "metaDescription": "Как составить программу вечера для дня рождения в ресторане. Тайминг, подача блюд, тосты, торт. Советы от «Парусов на крыше».",
    "keywords": "программа вечера день рождения ресторан, сценарий праздника петербург, тайминг банкет",
    "date": "2026-06-27",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Хороший вечер — не случайность. Это правильный тайминг. Разбираем, как составить программу дня рождения в ресторане, чтобы всё получилось.",
    "sections": [
      {
        "heading": "Базовая структура вечера",
        "body": "19:00 — встреча гостей (аперитив, приветствие). 19:15–19:30 — все собрались, подаются холодные закуски. 20:00 — горячие закуски. 20:30 — горячее основное блюдо. 21:00–21:30 — поздравления и тосты. 21:45 — вынос торта с музыкой. 22:00 — десерт, свободное общение. Это базовый тайминг для 15–30 гостей.",
        "list": [
          "19:00 — встреча и аперитив",
          "19:30–20:30 — еда и горячее",
          "21:00 — поздравления и тосты",
          "21:45 — торт"
        ]
      },
      {
        "heading": "Как не дать вечеру «провиснуть»",
        "body": "Провисание обычно бывает между горячим и тостами — когда все поели, но ещё не дошли до торта. В этот момент хорошо работает: интерактивный конкурс от ведущего, видео-поздравление с экрана, живая музыка с акцентированным выходом. В «Парусах» музыканты могут сыграть что-то для именинника по запросу в этот момент.",
        "highlight": "Совет: не затягивайте поздравления больше 30 минут. Если гостей больше 20 — выберите 3–5 ключевых тостов, остальным дайте слово за десертом."
      },
      {
        "heading": "Роль ресторана в программе",
        "body": "Банкетный менеджер «Парусов» помогает составить тайминг под ваш вечер. Подача блюд координируется с вашей программой. Музыканты знают, когда включить яркую мелодию. Доверьтесь команде. +7 (812) 991-10-90.",
        "list": [
          "Менеджер помогает с таймингом",
          "Подача координируется с программой",
          "Музыканты — по вашему запросу",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить программу вечера", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "syurpriz-imeninniku-kak-organizovat",
    "title": "Сюрприз именинникам в ресторане: как организовать и не провалить",
    "metaTitle": "Сюрприз именинникам в ресторане — как организовать | Паруса",
    "metaDescription": "Как организовать сюрприз на день рождения в ресторане Санкт-Петербурга. Советы по координации с «Парусами на крыше».",
    "keywords": "сюрприз именинникам ресторан петербург, организовать сюрприз день рождения, тайное бронирование",
    "date": "2026-06-27",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Сюрприз на день рождения — рискованное мероприятие. Можно угадать с местом и попасть в «вот это да!» — или ошибиться и создать неловкость. Разбираем, как сделать правильно.",
    "sections": [
      {
        "heading": "Когда сюрприз работает",
        "body": "Сюрприз хорошо работает, когда: вы хорошо знаете вкусы именинника, место объективно впечатляющее (вид с 6-го этажа на Петербург — попадает в 90% людей), гости заранее предупреждены и не «сдали». «Паруса» — хороший выбор для сюрприза: место, которое говорит само за себя при входе.",
        "list": [
          "Вы знаете вкусы именинника",
          "Место объективно впечатляющее",
          "Гости не сдали сюрприз",
          "Придумайте легенду: «просто поужинаем»"
        ]
      },
      {
        "heading": "Как координировать с рестораном",
        "body": "Позвоните: +7 (812) 991-10-90. Скажите: «Организую сюрприз. Именинник не знает о ресторане. Когда мы войдём — попросите музыкантов сыграть... (мелодию)». Хороший ресторан это выполнит. В «Парусах» — это обычная просьба, выполняют с удовольствием.",
        "highlight": "Скажите менеджеру «это сюрприз» при бронировании. Команда будет готова создать момент входа. Это работает."
      },
      {
        "heading": "Что может пойти не так",
        "body": "Риски сюрприза: именинник не хочет публичного внимания (уточните характер заранее), кто-то из гостей нечаянно упоминает место. Митигация: договоритесь с гостями о секретности, уберите из группы чатов упоминания места. Если именинник — интроверт, возможно, лучше просто сказать ему куда идёте.",
        "list": [
          "Предупредите гостей: не рассекречивать",
          "Учтите характер именинника",
          "Интроверты могут не любить неожиданности",
          "Альтернатива: сказать куда идёте — тоже радость"
        ]
      }
    ],
    "cta": { "text": "Организовать сюрприз", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "gosti-den-rozhdeniya-kuda-priglasit",
    "title": "Гости на день рождения в ресторане: кого приглашать и сколько",
    "metaTitle": "Гости на день рождения в ресторане — сколько приглашать | Паруса",
    "metaDescription": "Сколько гостей пригласить на день рождения в ресторан Петербурга. Оптимальное количество и форматы.",
    "keywords": "гости день рождения ресторан петербург, сколько пригласить день рождения, список гостей ресторан",
    "date": "2026-06-28",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Сколько человек пригласить на день рождения в ресторан? Вопрос, от которого зависит всё: формат, бюджет, атмосфера. Разбираем логику.",
    "sections": [
      {
        "heading": "Оптимальное число гостей",
        "body": "Психологи говорят: оптимальное число для настоящего общения — 5–12 человек. Именно в этой группе каждый важен, все слышат друг друга, именинник успевает поговорить с каждым. Для ресторана это идеальный размер: один стол, живой вечер. 15–30 — уже небольшой банкет. 30+ — полноценное мероприятие.",
        "list": [
          "5–12: идеальный размер для общения",
          "15–30: небольшой банкет",
          "30–80: банкет с программой",
          "80+: крупное мероприятие"
        ]
      },
      {
        "heading": "Кого приглашать",
        "body": "Простое правило: приглашайте тех, с кем хотите провести этот конкретный вечер. Не «надо», не «обязательно», а «хочу». День рождения — ваш вечер, и каждый гость должен быть в нём намеренно. Это делает праздник лучше и для вас, и для гостей.",
        "highlight": "Лучший день рождения — тот, где все гости действительно хотели быть. Не из вежливости, а потому что вы для них важны."
      },
      {
        "heading": "Практический совет",
        "body": "Для первого раза в новом ресторане — возьмите небольшую компанию (8–12). Если место понравится — следующий праздник можно отметить с большей компанией. В «Парусах» работает и тот, и другой формат. +7 (812) 991-10-90.",
        "list": [
          "Первый раз в ресторане: 8–12 гостей",
          "Известное место: можно 20–50",
          "Скидка 20% именинникам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить размер компании", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-bez-gostey-odin-spb",
    "title": "День рождения без гостей в Петербурге: в одиночестве или вдвоём",
    "metaTitle": "День рождения без гостей в Петербурге | Паруса на крыше",
    "metaDescription": "Как провести день рождения без гостей в Санкт-Петербурге. Ужин в одиночестве или вдвоём с видом на город. Скидка 20% именинникам.",
    "keywords": "день рождения без гостей петербург, одиночество день рождения спб, день рождения один ресторан",
    "date": "2026-06-28",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Иногда лучший день рождения — без гостей. Просто вы, красивое место и пространство для размышлений. Или вдвоём с самым близким человеком. Это тоже праздник.",
    "sections": [
      {
        "heading": "День рождения в одиночестве — не грустно",
        "body": "Отмечать день рождения одному — осознанный выбор для многих. Время побыть с собой, подумать, отметить прошедший год и наступающий. Ресторан «Парусов» с видом на Петербург — идеальное место для этого. Отличный ужин, бокал хорошего вина, вид на купола — это подарок себе.",
        "list": [
          "Время для себя — законное право",
          "Ужин в одиночестве — нормальная практика",
          "Скидка 20% — и на одного",
          "Стол у окна с лучшим видом"
        ]
      },
      {
        "heading": "Ужин вдвоём вместо компании",
        "body": "Вдвоём с партнёром, другом или мамой — это тоже «без гостей». Два человека, один стол, один вечер. В «Парусах» это лучший формат для особого вечера: максимальная близость, минимум суеты.",
        "highlight": "День рождения вдвоём в «Парусах» — это иногда лучший подарок. Когда не нужно никому делать вид, что праздник для всех."
      },
      {
        "heading": "Бронирование",
        "body": "Стол на одного или двоих у окна. За 1–2 дня: +7 (812) 991-10-90. Скидка 20% именинникам.",
        "list": [
          "Стол на 1–2 у окна",
          "За 1–2 дня",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать особый вечер", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "tematicheskiy-den-rozhdeniya-restoran-spb",
    "title": "Тематический день рождения в ресторане Петербурга: идеи",
    "metaTitle": "Тематический день рождения в ресторане СПб | Паруса",
    "metaDescription": "Идеи для тематического дня рождения в ресторане Санкт-Петербурга. Как реализовать тему в «Парусах на крыше».",
    "keywords": "тематический день рождения ресторан петербург, тема праздника спб, стилизованный день рождения",
    "date": "2026-06-28",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Тематический день рождения — способ сделать праздник запоминающимся. Гэтсби, джаз, чёрно-белое, «петербургский стиль» — каждая тема создаёт свою атмосферу.",
    "sections": [
      {
        "heading": "Идеи тематических праздников",
        "body": "Гэтсби: золото, джаз, 1920-е — идеально в «Парусах» с живой музыкой. Чёрно-белое: элегантно, легко реализуется через дресс-код. Джазовая вечеринка: живая музыка + тематический декор + коктейли. Петербургский стиль: русская классика, дореволюционный шик. Природа: живые цветы, зелень, лёгкость — хорошо в летний сезон.",
        "list": [
          "Гэтсби: золото + джаз (идеально в «Парусах»)",
          "Чёрно-белое: дресс-код — элегантно",
          "Джаз 1950-х: живая музыка + коктейли",
          "Петербургский стиль: русская классика"
        ]
      },
      {
        "heading": "Как реализовать тему в ресторане",
        "body": "Дресс-код: попросите гостей одеться по теме — это самый дешёвый и эффективный способ создать атмосферу. Декор: флорист по вашей теме, принесите до начала вечера. Музыка: попросите музыкантов сыграть тематические мелодии. Меню: можно попросить тематическое оформление блюд при большом банкете.",
        "highlight": "Тема Гэтсби в «Парусах» с живой джазовой музыкой и видом на ночной Петербург — это работает без лишних усилий. Место само создаёт эпоху."
      },
      {
        "heading": "Координация с рестораном",
        "body": "Позвоните: +7 (812) 991-10-90. Расскажите о теме. Менеджер скажет, что возможно и что нужно организовать самостоятельно. Скидка 20% именинникам.",
        "list": [
          "Позвоните, расскажите о теме",
          "Флорист — до начала вечера",
          "Дресс-код — организуете сами",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить тематический праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "ochen-krasivyy-prazdnik-dr-peterburg",
    "title": "Очень красивый день рождения в Петербурге: как устроить",
    "metaTitle": "Очень красивый день рождения в Петербурге | Паруса на крыше",
    "metaDescription": "Как устроить очень красивый день рождения в Санкт-Петербурге. Ресторан с видом, флористика, живая музыка. Скидка 20% именинникам.",
    "keywords": "красивый день рождения петербург, красивое место день рождения спб, организовать красивый праздник",
    "date": "2026-06-28",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "«Хочу очень красивый день рождения». Это нормальное желание — и оно выполнимо. Не нужен миллионный бюджет. Нужно правильное место и несколько правильных деталей.",
    "sections": [
      {
        "heading": "Что делает праздник красивым",
        "body": "Красивый праздник — это несколько элементов вместе: красивое место (видом на Петербург с 6-го этажа уже выигрышно), живые цветы на столе, живая музыка, красивая подача блюд, именной торт с поздравлением. Это не дорого по отдельности — а вместе создаёт то самое впечатление.",
        "list": [
          "Место: панорама Петербурга — главное",
          "Цветы: живые на стол — 500–3 000 ₽",
          "Живая музыка: входит в стоимость",
          "Торт: от шеф-кондитера под заказ"
        ]
      },
      {
        "heading": "Красота через детали",
        "body": "Именная карточка на столе. Шампанское при входе. Вид на закат (летом, в 20:00–22:00). Правильное освещение (в «Парусах» — хорошее). Эти детали не стоят почти ничего, а создают «вау» без всяких шаров и гирлянд.",
        "highlight": "Красота — в правильных деталях. Вид на Петербург на закате + живая музыка + цветы на столе = очень красивый праздник. Без героических бюджетов."
      },
      {
        "heading": "Бронирование",
        "body": "+7 (812) 991-10-90. Попросите стол у окна, скажите о дне рождения. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Попросите стол у окна",
          "Скажите о дне рождения",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать красивый праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "podgotovka-k-dniu-rozhdeniya-cheklik",
    "title": "Чеклист подготовки ко дню рождения в ресторане: ничего не забыть",
    "metaTitle": "Чеклист подготовки ко дню рождения в ресторане | Паруса",
    "metaDescription": "Полный чеклист подготовки ко дню рождения в ресторане Петербурга. Ничего не забыть. Советы от «Парусов на крыше».",
    "keywords": "чеклист день рождения ресторан петербург, подготовка праздника ресторан, организация дня рождения",
    "date": "2026-06-28",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Организация дня рождения в ресторане — задача, в которой легко что-то забыть. Чеклист ниже поможет не упустить важное.",
    "sections": [
      {
        "heading": "За 3–4 недели",
        "body": "Определитесь с: датой, количеством гостей, форматом (стол/зал), бюджетом. Позвоните в «Паруса»: +7 (812) 991-10-90. Забронируйте место. Уточните: скидка 20% именинникам, условия по торту, флористике, музыке. Отправьте приглашения гостям.",
        "list": [
          "Дата, гости, формат, бюджет",
          "Бронирование: +7 (812) 991-10-90",
          "Скидка 20% именинникам",
          "Разослать приглашения"
        ]
      },
      {
        "heading": "За 1–2 недели",
        "body": "Подтвердите количество гостей. Заполните детали с менеджером: тайминг вечера, подача торта, пожелания по музыке. Закажите торт (если через ресторан — за 5–7 дней). Договоритесь с флористом (если нужен).",
        "list": [
          "Подтвердите количество гостей",
          "Тайминг вечера с менеджером",
          "Торт: заказ за 5–7 дней",
          "Флорист — если нужен"
        ]
      },
      {
        "heading": "За день и в день",
        "body": "Накануне: перезвоните и подтвердите бронирование. В день: приехать на 30 мин раньше гостей (проверить стол, поставить цветы). Взять паспорт для скидки. Зарядить телефон для фото.",
        "highlight": "Самое важное: приедьте на 30 минут раньше. Тогда, когда придут гости, всё уже будет готово и вы спокойны.",
        "list": [
          "Накануне: подтвердить бронирование",
          "Приехать на 30 мин раньше",
          "Взять паспорт (скидка)",
          "Зарядить телефон"
        ]
      }
    ],
    "cta": { "text": "Начать планирование", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "nezabyvaemyy-dr-restoran-peterburg",
    "title": "Незабываемый день рождения в Петербурге: что делает его таким",
    "metaTitle": "Незабываемый день рождения в Петербурге | Паруса на крыше",
    "metaDescription": "Что делает день рождения незабываемым в Санкт-Петербурге. Правильное место, детали и атмосфера. Скидка 20% именинникам.",
    "keywords": "незабываемый день рождения петербург, запоминающийся праздник спб, день рождения на всю жизнь",
    "date": "2026-06-29",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Почему одни дни рождения вспоминают через 10 лет, а другие забывают через месяц? Разбираем, что делает праздник по-настоящему незабываемым.",
    "sections": [
      {
        "heading": "Наука памяти о праздниках",
        "body": "Исследования показывают: люди запоминают места и моменты, а не меню. Ресторан, где был открытый вид на город — запоминают. Первый глоток шампанского с видом на закат над Петербургом — запоминают. «Что именно ели» — нет. Отсюда вывод: инвестируйте в место и момент, а не в количество перемен блюд.",
        "list": [
          "Места запоминают, меню — нет",
          "Визуальные впечатления — самые сильные",
          "Момент выноса торта — всегда помнят",
          "Правильная компания усиливает всё"
        ]
      },
      {
        "heading": "Элементы незабываемого вечера",
        "body": "Панорамный вид — визуальный якорь, который будет ассоциироваться с этим вечером всю жизнь. Живая музыка в нужный момент — звуковой якорь. Личное поздравление от ресторана — тактильная деталь. Торт с именем — визуальная точка. В «Парусах» все четыре якоря реализованы.",
        "highlight": "Каждый незабываемый вечер держится на нескольких «якорях»: вид, звук, вкус, момент. «Паруса» дают три из четырёх автоматически."
      },
      {
        "heading": "Ваша роль в создании момента",
        "body": "Место создаёт условия — но момент создаёте вы. Будьте присутствующими. Смотрите на гостей, а не в телефон (хотя бы часть вечера). Произнесите слова, которые важны. Это то, что останется в памяти навсегда.",
        "list": [
          "Присутствуйте — не в телефоне",
          "Произнесите важные слова",
          "Сфотографируйте момент",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать незабываемый вечер", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "muzyka-dlya-dnya-rozhdeniya-restoran",
    "title": "Музыка для дня рождения в ресторане: живая или запись",
    "metaTitle": "Музыка для дня рождения в ресторане | Паруса на крыше",
    "metaDescription": "Живая музыка или запись на день рождения в ресторане. Почему живая музыка в «Парусах» делает праздник особенным.",
    "keywords": "музыка день рождения ресторан, живая музыка день рождения петербург, музыкальное сопровождение праздника",
    "date": "2026-06-29",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Живая музыка на день рождения — это другой уровень. Не лучше или хуже записи — просто другой. Разбираем разницу.",
    "sections": [
      {
        "heading": "Запись vs живая музыка",
        "body": "Запись: предсказуема, дешевле, работает всегда. Но она — фон. Живая музыка: непредсказуема в лучшем смысле, это живой человек, который реагирует на зал. Когда именинник входит — музыкант может сыграть его любимую мелодию. Когда вносят торт — мелодия становится частью момента. Это нельзя воспроизвести плейлистом.",
        "list": [
          "Живая: реагирует на момент",
          "Живая: создаёт уникальные ситуации",
          "Запись: предсказуема и надёжна",
          "В «Парусах»: живая музыка чт–вс"
        ]
      },
      {
        "heading": "Живая музыка в «Парусах»",
        "body": "С четверга по воскресенье в «Парусах» играет живая музыка. Жанры — уточните при бронировании. Можно попросить исполнить конкретную мелодию в нужный момент. Это входит в стоимость вечера — без доплат.",
        "highlight": "Попросите музыкантов сыграть что-то для именинника при выносе торта. Это тот момент, который снимают и показывают потом."
      },
      {
        "heading": "Если день рождения не чт–вс",
        "body": "В понедельник-среду живой музыки нет — только запись. Для дня рождения в эти дни компенсация — более тихая атмосфера и более свободный выбор стола. Скидка 20% именинникам действует каждый день. +7 (812) 991-10-90.",
        "list": [
          "Чт–вс: живая музыка",
          "Пн–ср: только запись",
          "Скидка 20% ежедневно",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать с живой музыкой", "href": "/zhivaya-muzyka" }
  },
  {
    "slug": "luchshee-mesto-dr-peterburg-2026",
    "title": "Лучшее место для дня рождения в Петербурге 2026: честный обзор",
    "metaTitle": "Лучшее место для дня рождения в Петербурге 2026 | Паруса",
    "metaDescription": "Честный обзор лучших мест для дня рождения в Санкт-Петербурге 2026. Рейтинг, критерии, почему «Паруса на крыше» — выбор №1.",
    "keywords": "лучшее место день рождения петербург 2026, топ рестораны день рождения спб, рейтинг рестораны праздник",
    "date": "2026-06-29",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Какое место в Петербурге лучшее для дня рождения в 2026 году? Разбираем по критериям: вид, кухня, сервис, доступность. Честно.",
    "sections": [
      {
        "heading": "Критерии выбора места для праздника",
        "body": "Пять критериев, которые важны для дня рождения: вид или атмосфера (что создаёт настроение), кухня (что и как готовят), сервис (как относятся к гостям), доступность (легко ли добраться, есть ли парковка), гибкость (можно ли под вас адаптировать вечер). «Паруса на крыше» получают высокие баллы по всем пяти.",
        "list": [
          "Вид: 6-й этаж, 300° на центр Петербурга",
          "Кухня: авторская, сезонная",
          "Сервис: рейтинг 5,0, «Хорошее место 2026»",
          "Доступность: центр, парковка, метро"
        ]
      },
      {
        "heading": "Почему «Паруса» — выбор №1",
        "body": "«Паруса на крыше» — единственный ресторан в Петербурге, который сочетает: панорамный вид 300° на исторический центр, авторскую кухню с сезонными блюдами, живую музыку без доплаты и скидку 20% именинникам. По отдельности это есть у многих. Всё вместе — только здесь.",
        "highlight": "Рейтинг 5,0 на Яндексе с 2 606+ отзывами. «Хорошее место 2026». Работаем с 2009 года. Это не случайность — это результат."
      },
      {
        "heading": "Контакты и бронирование",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, Olympic Plaza, 6-й этаж. Скидка 20% именинникам — 7 дней до и после ДР.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, 6-й этаж",
          "Скидка 20% именинникам",
          "Работаем с 2009 года"
        ]
      }
    ],
    "cta": { "text": "Забронировать лучшее место", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "podarki-na-den-rozhdeniya-idei-restoran",
    "title": "Подарки на день рождения: идеи, которые связаны с рестораном",
    "metaTitle": "Подарки на день рождения — идеи с рестораном | Паруса",
    "metaDescription": "Идеи подарков на день рождения, связанных с рестораном в Петербурге. Сертификаты, ужин, особый вечер.",
    "keywords": "подарки день рождения ресторан петербург, подарочный сертификат ресторан спб, что подарить ужин",
    "date": "2026-06-29",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Что подарить на день рождения? Впечатление — лучше, чем вещь. Ужин в «Парусах» — это подарок, который запоминается.",
    "sections": [
      {
        "heading": "Ужин как подарок",
        "body": "Подарить ужин в ресторане — это дать человеку опыт. Не вещь, которая пылится на полке, а вечер с видом на Петербург, живой музыкой и хорошей едой. Купите ужин на двоих в «Парусах» как подарок — это запомнится.",
        "list": [
          "Ужин на двоих — конкретный подарок",
          "Опыт важнее вещи",
          "Вечер с видом на Петербург",
          "Скидка 20% именинникам (плюс к подарку)"
        ]
      },
      {
        "heading": "Сертификат в «Паруса»",
        "body": "Хотите подарить «Паруса» — уточните о подарочных сертификатах при звонке. Сертификат на определённую сумму — удобно, если не знаете когда именинник сможет прийти. Он сам выберет дату и воспользуется.",
        "highlight": "Подарочный ужин в «Парусах» — это подарок, о котором говорят: «О, ты помнишь мой день рождения в прошлом году? Паруса — лучшее, что было»."
      },
      {
        "heading": "Как договориться",
        "body": "+7 (812) 991-10-90. Скажите, что хотите подарить ужин имениннику. Уточните о сертификатах.",
        "list": [
          "+7 (812) 991-10-90",
          "Уточните о сертификатах",
          "Ужин на двоих — конкретный вариант",
          "Скидка 20% именинникам сверху"
        ]
      }
    ],
    "cta": { "text": "Подарить ужин в «Парусах»", "href": "/sertifikat" }
  },
  {
    "slug": "prazdnik-sotrudnika-restoran-peterburg",
    "title": "Праздник сотрудника в ресторане Петербурга: корпоративная культура",
    "metaTitle": "Праздник сотрудника в ресторане Петербурга | Паруса",
    "metaDescription": "Как правильно отметить день рождения сотрудника в ресторане Санкт-Петербурга. Корпоративная культура и практика. Скидка 20% именинникам.",
    "keywords": "праздник сотрудника ресторан петербург, корпоратив день рождения спб, отметить сотрудника",
    "date": "2026-06-30",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Компании, которые отмечают дни рождения сотрудников, удерживают людей лучше. Это не просто традиция — это инвестиция в команду. Разбираем, как делать это правильно.",
    "sections": [
      {
        "heading": "Почему это важно для компании",
        "body": "По исследованиям, 67% сотрудников чувствуют большую лояльность к компании, которая отмечает их личные праздники. Ужин в честь дня рождения сотрудника в «Парусах» — это конкретное действие, которое говорит: «ты важен». Это дешевле, чем поднимать зарплату, но часто более эффективно для мотивации.",
        "list": [
          "Лояльность через личное внимание",
          "Дешевле повышения, эффективнее слова",
          "Укрепляет командную культуру",
          "Скидка 20% имениннику-сотруднику"
        ]
      },
      {
        "heading": "Формат корпоративного дня рождения",
        "body": "Небольшой ужин командой (5–12 человек) — оптимально. Руководитель делает тост. Торт с именем. Живая музыка. 2 часа за столом с видом на Петербург. Это лучший корпоративный бонус, который не требует бюрократии.",
        "highlight": "Ужин в «Парусах» в честь дня рождения сотрудника — это то, о чём говорят в офисе. «Помнишь, как меня поздравили? Вот это было круто». Это и есть культура."
      },
      {
        "heading": "Практика",
        "body": "За 3–5 дней: +7 (812) 991-10-90. Скажите: «корпоративный день рождения». Безналичный расчёт — уточните. Скидка 20% сотруднику-имениннику.",
        "list": [
          "За 3–5 дней",
          "+7 (812) 991-10-90",
          "Безналичный расчёт — по запросу",
          "Скидка 20% имениннику"
        ]
      }
    ],
    "cta": { "text": "Забронировать для сотрудника", "href": "/korporativ" }
  },
  {
    "slug": "den-rozhdeniya-pensionera-restoran-spb",
    "title": "День рождения пенсионера в Петербурге: как выбрать правильно",
    "metaTitle": "День рождения пенсионера в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения пенсионера в Санкт-Петербурге. Комфортный ресторан с хорошей кухней. Скидка 20% именинникам.",
    "keywords": "день рождения пенсионера ресторан петербург, праздник пожилых спб, день рождения старшего возраста",
    "date": "2026-06-30",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "День рождения пожилого человека — особая ответственность. Комфорт, достоинство, хорошая еда — это то, что важно. Выбирайте место, которое это понимает.",
    "sections": [
      {
        "heading": "Что важно для пожилого именинника",
        "body": "Три главных критерия: комфорт (хороший лифт, удобные кресла, не слишком громко), достоинство (место, которое уважает гостей любого возраста), кухня (классическая, понятная, без экспериментов). «Паруса на крыше» в Olympic Plaza дают все три: лифт, удобные залы, меню с классическими блюдами.",
        "list": [
          "Лифт в Olympic Plaza",
          "Удобные залы, хорошее освещение",
          "Классическая кухня",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Атмосфера без суеты",
        "body": "Пожилые люди ценят тишину и неспешность. В «Парусах» музыка не громкая, персонал не торопит, атмосфера достойная. Вид на Петербург — то, что нравится всем возрастам без исключения. Именно за этот вид и возвращаются.",
        "highlight": "Пожилой именинник, который видит Петербург с 6-го этажа — это тот момент, когда место оправдывает себя сразу."
      },
      {
        "heading": "Организация",
        "body": "Ранний вечер: 17:00–18:00 — лучшее время для пожилых. За 1–2 недели: +7 (812) 991-10-90. Скидка 20% именинникам.",
        "list": [
          "17:00–18:00 — ранний вечер",
          "За 1–2 недели",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать для пожилого именинника", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "prazdnik-bez-alkogolya-restoran-spb",
    "title": "День рождения без алкоголя в ресторане Петербурга: как это работает",
    "metaTitle": "День рождения без алкоголя в ресторане СПб | Паруса",
    "metaDescription": "Как провести день рождения без алкоголя в ресторане Санкт-Петербурга. Безалкогольные напитки, моктейли, соки. Скидка 20% именинникам.",
    "keywords": "день рождения без алкоголя ресторан петербург, безалкогольный праздник спб, трезвый день рождения",
    "date": "2026-06-30",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "День рождения без алкоголя — растущий тренд. Не все пьют, и это нормально. Разбираем, как провести праздник в ресторане без алкоголя, не теряя атмосферы.",
    "sections": [
      {
        "heading": "Безалкогольный праздник: как это сделать вкусно",
        "body": "Ресторан без алкоголя — не значит без атмосферы. В «Парусах» отличная карта безалкогольных напитков: свежевыжатые соки, авторские лимонады, моктейли (коктейли без алкоголя), горячий чай и кофе, безалкогольное игристое. Праздник строится вокруг еды и общения — алкоголь необязателен.",
        "list": [
          "Авторские моктейли",
          "Свежевыжатые соки",
          "Безалкогольное игристое — для торжественного момента",
          "Горячий чай и кофе"
        ]
      },
      {
        "heading": "Как объяснить гостям",
        "body": "Скажите прямо: «Это безалкогольный вечер». Большинство гостей отнесутся с пониманием — особенно если предложены вкусные альтернативы. Безалкогольное игристое для тоста — хороший компромисс.",
        "highlight": "Безалкогольный тост с красивым безалкогольным игристым в правильных бокалах — это та же атмосфера. Важны бокалы и слова, а не содержимое."
      },
      {
        "heading": "Практически",
        "body": "Скажите о безалкогольном формате при бронировании. Менеджер порекомендует варианты напитков. Скидка 20% именинникам — на весь личный счёт, включая безалкогольные. +7 (812) 991-10-90.",
        "list": [
          "Скажите о безалкогольном при брони",
          "Менеджер порекомендует напитки",
          "Скидка 20% на весь счёт",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать безалкогольный праздник", "href": "/den-rozhdeniya" }
  }
];
